'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OpenrestClient = function () {
    function OpenrestClient(_ref) {
        var XMLHttpRequest = _ref.XMLHttpRequest,
            _ref$timeout = _ref.timeout,
            timeout = _ref$timeout === undefined ? 0 : _ref$timeout,
            _ref$apiUrl = _ref.apiUrl,
            apiUrl = _ref$apiUrl === undefined ? 'https://api.wixrestaurants.com/v1.1' : _ref$apiUrl;

        _classCallCheck(this, OpenrestClient);

        this.apiUrl = apiUrl;
        this.timeout = timeout;
        this.XMLHttpRequest = XMLHttpRequest;
    }

    _createClass(OpenrestClient, [{
        key: 'request',
        value: function request(_ref2) {
            var _ref2$request = _ref2.request,
                _request = _ref2$request === undefined ? {} : _ref2$request,
                _ref2$callback = _ref2.callback,
                callback = _ref2$callback === undefined ? function () {} : _ref2$callback;

            var xhr = new this.XMLHttpRequest();

            xhr.ontimeout = function () {
                return callback({
                    error: 'timeout',
                    errorMessage: 'request timed out'
                });
            };

            xhr.onerror = function () {
                return callback({
                    error: 'network_down',
                    errorMessage: 'network is down'
                });
            };

            xhr.onload = function () {
                var response = null;
                try {
                    response = JSON.parse(xhr.responseText);
                } catch (e) {
                    callback({
                        error: 'protocol',
                        errorMessage: 'protocol error'
                    });
                    return;
                }

                callback(response);
            };

            xhr.open('POST', this.apiUrl, true);
            xhr.timeout = this.timeout;
            xhr.setRequestHeader('Accept', 'application/json');
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.send(JSON.stringify(_request));
        }
    }]);

    return OpenrestClient;
}();

exports.default = OpenrestClient;


//////////////////
// WEBPACK FOOTER
// ../node_modules/openrest4js/dist/openrest4js-client/OpenrestClient.js
// module id = 740
// module chunks = 0